import axios from "axios";
import { $axiosInterceptor } from "./axiosInterceptor.js";

const $axios = 
{
    // GET 호출
    async get(url, auth) 
    {
        let response = null;
        try {
            let config = auth ? {"headers": {"_AUTH_": `${auth}`}} : {};
            response = await axios.get(url, config);
        } catch(error) {
            response = error.response;
        }
        return response;
    },
    // POST 호출
    async post(url, param, auth) 
    {
        let response = null;
        try {
            let config = auth ? {"headers": {"_AUTH_": `${auth}`}} : {};
            response = await axios.post(url, param, config);
        } catch(error) {
            response = error.response;
        }
        return response;
    },
    // PUT 호출
    async put(url, param, auth) 
    {
        let response = null;
        try {
            let config = auth ? {"headers": {"_AUTH_": `${auth}`}} : {};
            response = await axios.put(url, param, config);
        } catch(error) {
            response = error.response;
        }    
        return response;
    },
    // DELETE 호출
    async delete(url, param, auth) 
    {
        let response = null;
        try {
            let config = auth ? {"headers": {"_AUTH_": `${auth}`}} : {};
            response = await axios.delete(url, param, config);
        } catch(error) {
            response = error.response;
        }     
        return response;
    },
    // axios 인터셉터 요청처리
    interceptorsRequest()
    {
        $axiosInterceptor.interceptorsRequest();
    },
    // axios 인터셉터 응답처리
    interceptorsResponse()
    {
        $axiosInterceptor.interceptorsResponse();
    },
}

export {
    $axios
}